import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import GetAppIcon from '@material-ui/icons/GetApp';
import React, { useEffect, useMemo, useState } from 'react';
import { IGuide } from 'src/actions/help';
import {
	handleDownloadLinkPropsForIe,
	IDownloadAnchor,
} from 'src/utils/download';
import i18next from '../resources/i18n';
/**
 * スタイル定義
 */
const useStyles = makeStyles(
	theme => ({
		root: {
			flexGrow: 1,
			margin: theme.spacing(1),
			padding: theme.spacing(1),
		},
		row: {
			// padding: theme.spacing(1),
		},
	}),
	{}
);

/**
 * CommonHelp のProps型
 */
export interface IHelpProps {
	/**
	 * 表示対象ヘルプリスト
	 */
	guides: IGuide[];
}

/**
 * CommonHelp のAction型
 */
export interface IHelpActions {
	/**
	 * INITIALIZE
	 */
	init(): void;
}

/**
 * CommonHelp の合成済みProps型
 */
interface IProps extends IHelpProps, IHelpActions {}

interface IHelpRowProps {
	guide: IGuide;
	index: number;
}
/**
 * ヘルプ一覧テーブルの行コンポーネント
 * @param guide ヘルプ内容
 * @param i index
 */
function Row({ guide, index: i }: IHelpRowProps) {
	const { row } = useStyles();

	// リンク先
	const target: IDownloadAnchor = useMemo(
		() => ({
			download: guide.name,
			href: `${process.env.PUBLIC_URL}/${guide.path}`,
		}),
		[guide.name, guide.path]
	);

	// IEモード向けにpropsを差し替え
	const linkProps = useMemo(() => handleDownloadLinkPropsForIe(target), [
		target,
	]);

	return (
		<TableRow key={i} className={row}>
			<TableCell>
				<Chip label={i + 1} color="primary" />
			</TableCell>
			<TableCell>{guide.title}</TableCell>
			<TableCell size="small">{guide.description}</TableCell>
			<TableCell>
				<Button
					variant="contained"
					color="default"
					size="small"
					className="download-button"
					{...linkProps}
				>
					<GetAppIcon />
					{i18next.t('CommonHelp_0001')}
				</Button>
			</TableCell>
		</TableRow>
	);
}

/**
 * ヘルプ画面共通コンポーネント
 * @param props
 */
const CommonHelp: React.FC<IProps> = ({ guides, init }) => {
	const classes = useStyles();

	/** 読み込み済みか否か */
	const [loaded, setLoaded] = useState(false);

	// マウント時初期化
	useEffect(() => {
		// 初回のみ初期化
		if (!loaded) {
			init();
			setLoaded(true);
		}
	}, []);

	return (
		<Paper className={classes.root}>
			<Table>
				<TableBody>
					{guides.map((guide, index) => (
						<Row key={guide.path} guide={guide} index={index} />
					))}
				</TableBody>
			</Table>
		</Paper>
	);
};

export default CommonHelp;



// WEBPACK FOOTER //
// ./src/components/CommonHelp.tsx